import api from 'services/api';

import {
  InventoryData,
  ISearchParamsAPI,
  ISearchPerPage,
  IGetCollectParams,
  DetailInventoryData,
} from '../types';

export const searchBoxRequest = async (data: ISearchParamsAPI) => {
  return api.patch(`Relatorio/ArmazenagemEstoque`, {
    ...data,
  });
};

export const searchBoxRequestByExcel = async (data: ISearchParamsAPI) => {
  return api.patch('Relatorio/ArmazenagemEstoque/Excel', data, {
    responseType: 'blob',
  });
};

export const searchBoxPaginate = async (data: ISearchPerPage) => {
  return api.patch('Relatorio/ArmazenagemEstoque/Excel', data, {
    responseType: 'blob',
  });
};

export const getSellerOptionsAPI = () => api.get(`receipts/sellers`);

export const getAllOptions = async (clientId: number) => {
  const [
    deposits,
    branchs,
    level1,
    brands,
    enableReservedParameter,
    enableSellerInput,
    orderTypes,
    users,
    erpDeposits,
    enableShoppingCartParameter,
  ] = await Promise.all([
    api.get(`Common/Deposito?CodigoCliente=${clientId}`),
    api.get(`Recebimento/searchbranch?CodigoCliente=${clientId}`),
    api.get(`Common/EstruturaMercadologica?CodigoCliente=${clientId}&Nivel=0`),
    api.get(`Common/Marca?CodigoCliente=${clientId}`),
    api.get(
      `Common/ParametroGenerico?CodigoCliente=${clientId}&Chave=PARAM_APRESENTA_PEDIDO_RESERVA`
    ),
    api.get(
      `Common/ParametroGenerico?CodigoCliente=${clientId}&Chave=PARAM_FILTRO_SELLLER_ESTOQUE`
    ),
    getOrderTypeOptionsAPI(clientId),
    getUserOptionsAPI(clientId),
    getErpDepositOptionsAPI(clientId),
    api.get(
      `Common/ParametroGenerico?CodigoCliente=${clientId}&Chave=PARAM_CARRINHO_PRATILEIRA`
    ),
  ]);

  return [
    deposits,
    branchs,
    level1,
    brands,
    enableReservedParameter,
    enableSellerInput,
    orderTypes,
    users,
    erpDeposits,
    enableShoppingCartParameter,
  ];
};

export const getCollectAPI = (params: IGetCollectParams) =>
  api.get(`Relatorio/ArmazenagemEstoqueDetalhe/Reserva`, { params });

export const getNigel2API = (clientId: number, codeNivel: string) =>
  api.get(
    `Common/EstruturaMercadologica?CodigoCliente=${clientId}&Nivel=1&CodigoPai=${codeNivel}`
  );

export const getNigel3API = (clientId: number, codeNivel: string) =>
  api.get(
    `Common/EstruturaMercadologica?CodigoCliente=${clientId}&Nivel=2&CodigoPai=${codeNivel}`
  );

export const getNigel4API = (clientId: number, codeNivel: string) =>
  api.get(
    `Common/EstruturaMercadologica?CodigoCliente=${clientId}&Nivel=3&CodigoPai=${codeNivel}`
  );

export const getNigel5API = (clientId: number, codeNivel: string) =>
  api.get(
    `Common/EstruturaMercadologica?CodigoCliente=${clientId}&Nivel=4&CodigoPai=${codeNivel}`
  );

export const detailsRequest = async (data: InventoryData) =>
  api.patch<DetailInventoryData[]>('Relatorio/ArmazenagemEstoqueDetalhe', {
    ...data,
  });

export const getOrderTypeOptionsAPI = (clientId: number) =>
  api.get(`Common/TipoPedido?CodigoCliente=${clientId}`);

export const getUserOptionsAPI = (clientId: number) =>
  api.get(`Usuario/Cliente?CodigoCliente=${clientId}`);

export const getErpDepositOptionsAPI = (clientId: number) =>
  api.get(`Common/Deposito/Erp?CodigoCliente=${clientId}`);
